import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CalendarTypeOption } from '../../services/definitions.service';

interface Event {
  start: Date;
  end: Date;
  name: string;
  type: string;
  parentPath?: string;
}

@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
})
export class EventDialogComponent {
  eventTitle: string;
  eventStartDate: Date;
  eventStartTime: string;
  eventEndDate: Date;
  eventEndTime: string;
  selectedCalendarId: string;
  calendarOptions: CalendarTypeOption[] = [];
  private readonly defaultEventType: string = 'standard';

  constructor(
    public dialogRef: MatDialogRef<EventDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.eventStartDate = data.date;
    this.eventEndDate = data.date;
    this.eventStartTime = '09:00';
    this.eventEndTime = '10:00';
    this.calendarOptions = data.eventTypes || [];
    if (this.calendarOptions.length > 0) {
      this.selectedCalendarId = this.calendarOptions[0].value;
    }
    if (data.selectedCalendarId) {
      this.selectedCalendarId = data.selectedCalendarId;
    }

    if (data.event) {
      this.eventTitle = data.event.name;
      this.eventStartDate = this.asDate(data.event.start);
      this.eventEndDate = this.asDate(data.event.end);
      this.eventStartTime = this.formatTime(this.eventStartDate);
      this.eventEndTime = this.formatTime(this.eventEndDate);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    if (this.eventTitle && this.eventStartDate && this.eventEndDate && this.selectedCalendarId) {
      const startDate = this.combineDateAndTime(this.eventStartDate, this.eventStartTime);
      let endDate = this.combineDateAndTime(this.eventEndDate, this.eventEndTime);

      if (endDate < startDate) {
        endDate = new Date(startDate);
      }

      this.dialogRef.close({ 
        name: this.eventTitle,
        start: startDate, 
        end: endDate,
        calendarId: this.selectedCalendarId,
        type: this.data?.event?.type || this.defaultEventType,
      });
    }
  }

  getStartTimeMax(): string | null {
    return this.isSameDay(this.eventStartDate, this.eventEndDate) ? this.eventEndTime : null;
  }

  getEndTimeMin(): string | null {
    return this.isSameDay(this.eventStartDate, this.eventEndDate) ? this.eventStartTime : null;
  }

  private formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  private combineDateAndTime(date: Date, time: string): Date {
    const [hours, minutes] = time.split(':').map(Number);
    const combinedDate = new Date(date);
    combinedDate.setHours(hours, minutes, 0, 0);
    return combinedDate;
  }

  private isSameDay(left: Date, right: Date): boolean {
    if (!left || !right) {
      return false;
    }

    return (
      left.getFullYear() === right.getFullYear() &&
      left.getMonth() === right.getMonth() &&
      left.getDate() === right.getDate()
    );
  }

  private asDate(value: any): Date {
    if (value?.toDate) {
      return value.toDate();
    }

    return new Date(value);
  }
}
